import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput, RadioGroup, Radio } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CLIENT_SETTING_VAL, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MIXSLIT_ENTRYTYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faGem, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, calculateTotalWeight, funCheckNumber } from "../../Utility/utility"
import { Box, Typography } from "@mui/material"
import { setIsMemoRedirect, setRedirectLink } from "../../state/accountSlice"



const CreateMixSlitEntry = () => {
    const { compCode, isMultipleCompany, compState } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.mixslitEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { mtrdtype, mptype } = useParams();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    //const [selBillType, setSelBillType] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const [mixStockParams, setMixStockParams] = useState("")
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [ClientSetting, setClientSetting] = useState("")
    const [isGetMixStock, setIsGetMixStock] = useState(true)
    const dispatch = useDispatch();
    const gridContainerRef = useRef(null);
    const mixGridContainerRef = useRef(null);
    const [pageNaviUrl, setPageNaviUrl] = useState("")
    const [mktLotNo, setMktLotNo] = useState("0")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)


    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMasterData } = usePost({
        url: apiRoute.mixslitEntry.entryMasterData,
        queryKey: "fetchMemoMasterData",

    })



    const ENUM_GRID = {
        MixGrid: "mixGrid",
        SourceGrid: "sourceGrid"
    }

    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.memoEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    let index = selectedGridRowId
                    const newRows = [...mixRows]

                    if (!toast.isActive('toats_chkRoughno')) {
                        toast.error("Duplicate Rough No not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkRoughno",
                        })
                    }
                    mixRows[index][RowsField.lotNo] = ""
                    setMixRows(newRows)
                }
            }

        }

    })
    const [selMixSlitType, setSelMixSlitType] = useState(ENUM_MIXSLIT_ENTRYTYPE.MixToMix)
    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePost({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    const newRows = [...mixRows]
                    let msg = ""

                    if (!toast.isActive('toats_chkpktlot')) {
                        toast.error("Duplicate Pkt No And Lot No Not Allow", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toats_chkpktlot",


                        })
                    }
                    let index = selectedGridRowId
                    newRows[index][RowsField.lotNo] = ''
                    newRows[index][RowsField.pktNo] = ''
                    setMixRows(newRows)
                }
            }
        }


    })


    const { data: mixStockData = [], mutate: filterMixStock } = usePost({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchMixStockData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {

                if (data[0].pcs > 0 && data[0].weight > 0) {

                    const newRows = [...rows]
                    let index = selectedGridRowId ?? 0

                    // if (newRows[index][RowsField.detailId] == 0) {
                    newRows[index][RowsField.stkPcs] = data[0].pcs
                    newRows[index][RowsField.stkWeight] = data[0].weight
                    newRows[index][RowsField.stkRate] = data[0].cost_amtrs
                    newRows[index][RowsField.stkDRate] = data[0].ret_cost_amtd
                    // }

                    setRows(newRows)
                    const newObject = Object.keys(mixStockParams).reduce((accumulator, key) => {
                        accumulator[key] = ''
                        return accumulator;
                    }, {});
                    setMixStockParams(newObject)
                    toast.dismiss("toast_mixstock1");
                    if (newRows[index][RowsField.detailId] <= 0) {
                        if (!toast.isActive("toast_mixstockf")) {
                            toast.success("Mix Stock Found", {
                                "position": "top-center",
                                toastId: "toast_mixstockf"
                            })
                        }
                    }


                }
                else {
                    //setTimeout(() => {
                    if (!toast.isActive("toast_mixstock1") && !toast.isActive("toast_mixstockf")) {
                        toast.error("Mix Stock Not Found", {
                            "position": "top-center",
                            "className": "toast-error",
                            toastId: "toast_mixstock1"
                        })
                    }
                    // }, 1000)
                }

            }
            else {

                if (!toast.isActive("toast_mixstock")) {
                    toast.error("Mix  Stock Not Found", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toast_mixstock"
                    })
                }
            }
        }

    })

    const { mutate: CheckMixStock } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchcheckMixStockData",

    })

    const funGenVouNo = (tradeOf) => {
        if (tradeOf != "") {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    trade_of: tradeOf,

                }

            })
        }
    }

    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: String(data[0]?.new_vou_no ?? ''),
            }))
        }
    }

    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.mixslitEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })

    const onSuccessTasks = (data) => {
        navigate(funGetMasterLink());
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.mixslitEntry.add_update,
        queryKey: "funAddUpdateMixSlit",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.mixslitEntry.fetchEntryDetail,
        queryKey: "fetchMemoDetail",
    });



    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })
    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {

            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    setMktLotNo("")
                    if (!toast.isActive("mktlcode")) {
                        toast.error("Lot No Series Not Found", {
                            "position": "top-center",
                            toastId: "mktlcode"
                        })
                    }
                    setFormData({ ...formData, [formField.mDate]: null })
                }
                else {
                    setMktLotNo(data[0].Mkt_LCode)
                }
            }
            else
                setMktLotNo('0')

        }

    })
    const funMktLotNo = (date) => {
        if (isNewEntry && !isUseMfgNoAsMktno) {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    const isSinglePacket = () => {
        if (mptype != "") {
            if (mptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    let gridData = []
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)

        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(mtrdtype))

            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(mptype))
            navigate(linksUrl.dashboard)

        if (mtrdtype && mtrdtype != "" && mptype && mptype != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_pktType = ''
            let t_trdtype = mtrdtype.toLowerCase()
            let modName = ''

            if (mptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'

            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                modName = isSinglePacket() ? ENUM_MOD_NAME.MixSlitPolishSingle : ENUM_MOD_NAME.MixSlitPolishMix
                setnaviCode(linksUrl.mixslitEntry.polishDiamond)
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                modName = isSinglePacket() ? ENUM_MOD_NAME.MixSlitRoughSingle : ENUM_MOD_NAME.MixSlitRoughMix
                setnaviCode(linksUrl.mixslitEntry.roughDiamond)
            }

            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            filterMasterData({
                data: {
                    compcode: compCode.join(","),
                    tradeof: t_tradeof,
                }
            })
            if (isNewEntry)
                funGenVouNo(t_tradeof)
            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })

            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, trade_of } = detailParams

                funGetDetail({
                    data: {
                        compcode: String(comp_code),
                        transactionid: transaction_id,
                        // billtype: selBillType,
                        tradeof: trade_of
                    }
                })
            }
        }
    }, [mptype, mtrdtype])

    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            const client_Type = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.ClientSettingType, generalData) ?? ENUM_CLIENT_SETTING_VAL.DUAL
            //if(isNewEntry && client_Type==ENUM_CLIENT_SETTING_VAL.MIX)
            // setSelMixSlitType(ENUM_)
            setClientSetting(client_Type)
            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,


                },
                Value: {
                    [RowsField.itemCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,

                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    // "allowNegativeStock": selBillType == 'S' ? getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.AllowNegativeStock, modData) ?? false : false,


                },
                MixStock:
                    selTradeOf == "R" ? {
                        [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByItem, generalData) ?? false,
                        [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData) ?? false,
                        [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockBySize, generalData) ?? false,
                    } : {
                        [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByItem, generalData) ?? false,
                        [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLCode, generalData) ?? false,
                        [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByShape, generalData) ?? false,
                        [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByColor, generalData) ?? false,
                        [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByPurity, generalData) ?? false,
                        [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLwRatio, generalData) ?? false,
                        [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockBySize, generalData) ?? false,
                    }


            })
        }

    }, [modSetting])

    useEffect(() => {
        if (modSettingParams && modSettingParams?.MixStock) {
            let array = Object.entries(modSettingParams?.MixStock).filter(([key, value]) => value == true).map(([key]) => { return { [key]: "" } })

            const result = array.reduce((acc, obj) => {
                return { ...acc, ...obj }
            }, {})
            if (mixStockParams == "")
                setMixStockParams(result)
        }
    }, [modSettingParams])


    const funGetAmtD = (carat, rate, crate) => {
        let dRate = parseFloat(rate ?? 0) / parseFloat(crate ?? 0)
        let amt = parseFloat(carat ?? 0) * parseFloat(dRate ?? 0)
        return funCheckNumber(amt).toFixed(2)
    }
    const funGetAmt = (carat, rate) => {
        let amt = parseFloat(carat ?? 0) * parseFloat(rate ?? 0)
        return funCheckNumber(amt).toFixed(2)
    }


    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        mDate: "mDate",
        locationId: "locationId",

    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.mDate)
            acc[key] = new Date()
        else if (key == formField.transId)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [deletedItemMixRows, setDeletedItemMixRows] = useState([])
    const [rows, setRows] = useState([])
    const [mixRows, setMixRows] = useState([])

    const total_OutAmount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const total_OutAmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_OutWeight = useMemo(
        () =>
            calculateTotalWeight({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_OutRate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_OutPcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const total_MergePcs = useMemo(
        () =>
            calculateTotal({
                data: mixRows,
                columnName: "pcs",
            }),
        [mixRows]
    )
    const total_MergeWeight = useMemo(
        () =>
            calculateTotalWeight({
                data: mixRows,
                columnName: "weight",
            }),
        [mixRows]
    )
    const total_MergeAmount = useMemo(

        () =>
            calculateTotal({
                data: mixRows,
                columnName: "amount",
            }),
        [mixRows]
    )

    const total_MergeAmountD = useMemo(

        () =>
            calculateTotal({
                data: mixRows,
                columnName: "dAmount",
            }),
        [mixRows]
    )

    const funGetAvgRate = (totalAmt, totalWeight) => {
        let avg = parseFloat(totalAmt) / parseFloat(totalWeight)
        return funCheckNumber(avg).toFixed(2)
    }

    const Avg_MergeRate = useMemo(() => funGetAvgRate(total_MergeAmount, total_MergeWeight), [mixRows])
    const Avg_MergeRateD = useMemo(() => funGetAvgRate(total_MergeAmountD, total_MergeWeight), [mixRows])
    const Avg_Rate = useMemo(() => funGetAvgRate(total_OutAmount, total_OutWeight), [rows])
    const Avg_RateD = useMemo(() => funGetAvgRate(total_OutAmountD, total_OutWeight), [rows])
    const RowsField = {
        detailId: "detailId",
        id: "id",
        transId: "transId",
        gridId: "gridId",
        itemCode: "itemCode",
        itemName: "itemName",
        shapeName: "shapeName",
        shapeCode: "shapeCode",
        pktNo: "pktNo",
        lotNo: "lotNo",
        purityName: "purityName",
        purityCode: "purityCode",
        colorName: "colorName",
        colorCode: "colorCode",
        sizeName: "sizeName",
        sizeCode: "sizeCode",
        lwRatio: "lwRatio",
        objLwRatio: "objLwRatio",
        amount: "amount",
        stkRate: "stkRate",
        stkPcs: "stkPcs",
        stkWeight: "stkWeight",
        stkDRate: "stkDRate",
        pcs: "pcs",
        weight: "weight",
        rate: "rate",
        convRate: "convRate",
        dRate: "dRate",
        dAmount: "dAmount",
        //outAmount: "outAmount",
        remarks: "remarks",
        reportNo: "reportNo",
        lab: "lab",
        oldWeight: "oldWeight",
        oldPcs: "oldPcs",
        bPcs: "bPcs",
        bWeight: "bWeight",


    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.transId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.shapeName]: "",
        [RowsField.shapeCode]: "",
        [RowsField.pktNo]: "",
        [RowsField.lotNo]: "",
        [RowsField.purityName]: "",
        [RowsField.purityCode]: "",
        [RowsField.colorName]: "",
        [RowsField.colorCode]: "",
        [RowsField.sizeName]: "",
        [RowsField.sizeCode]: "",
        [RowsField.lwRatio]: "",
        [RowsField.stkRate]: 0,
        [RowsField.stkDRate]: 0,
        [RowsField.amount]: 0,
        [RowsField.stkPcs]: 0,
        [RowsField.stkWeight]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.oldPcs]: 0,
        [RowsField.bPcs]: 0,
        [RowsField.bWeight]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.amount]: 0,
        [RowsField.rate]: 0,
        [RowsField.dAmount]: 0,
        [RowsField.dRate]: 0,
        [RowsField.convRate]: 0,
        [RowsField.remarks]: "",
        [RowsField.objLwRatio]: []


    }

    const itemGridHeadClass = "bill-grid-style"
    const mixGridHeadClass = "item-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })
    const getLwRatioByShape = (shape) => {
        if (masterData && Object.keys(masterData).length > 0)
            return masterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }

    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {

        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {
                //let t_DRate= (item?.Rs_Rate ?? 0 / item?.C_Rate ?? 0)

                return {
                    ...initialRow,
                    id: ++i,
                    gridId: ENUM_GRID.SourceGrid,
                    transId: item?.TransactionId ?? 0,
                    itemCode: item?.Item_Code ?? "",
                    pcs: item?.Pcs ?? 0,
                    weight: item?.Carat ?? 0,
                    rate: item?.Rs_Rate ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    dRate: item?.D_Rate ?? 0,
                    amount: funGetAmt(item?.Carat ?? 0, item?.Rs_Rate ?? 0),
                    dAmount: funGetAmtD(item?.Carat ?? 0, item?.Rs_Rate ?? 0, item?.C_Rate ?? 0),
                    detailId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    
                    lwRatio: item?.LW_Code ?? "",
                    objLwRatio: getLwRatioByShape(item?.S_Code ?? ""),
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sha_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    remarks: item?.Remarks ?? "",
                    oldPcs: item?.Pcs ?? "",
                    oldWeight: item?.Carat ?? "",
                }
            })


        }
    }


    const inputBoxes = {
        Row1: [
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Vou No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.mDate,
                name: formField.mDate,
                placeholder: "Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],



    }
    const funValidateStock = (id, index, gridId, chkPcsValue, chkWeightValue, value) => {
        let newRows = []
        if (isMixGrid(gridId))
            newRows = [...mixRows]
        else
            newRows = [...rows]

        if (id == RowsField.pcs) {
            if (Number(value) > Number(chkPcsValue)) {
                toast.error(`Pcs should be less than (${chkPcsValue})`, {
                    "position": "top-center",
                    "className": "toast-error",
                })
                newRows[index][RowsField.pcs] = chkPcsValue
            }

        }
        else if (id == RowsField.weight) {
            if (parseFloat(value) > parseFloat(chkWeightValue)) {
                toast.error(`Weight should be less than (${chkWeightValue})`, {
                    "position": "top-center",
                    "className": "toast-error",
                })
                newRows[index][RowsField.weight] = chkWeightValue
            }

        }
        if (isMixGrid(gridId))
            setMixRows(newRows)
        else
            setRows(newRows)
    }
    //console.log(rows)
    const handleBlur = (gridId, index, e, id) => {
        const { value } = e.target

        if (id == RowsField.lotNo || id == RowsField.pktNo) {

            setSelectedGridRowId(index)

            if (gridId == ENUM_GRID.MixGrid || gridId == ENUM_GRID.SourceGrid) {

                let newRows = [...rows]
                if (gridId == ENUM_GRID.MixGrid)
                    newRows = [...mixRows]
                let t_lotno = id == RowsField.lotNo ? value : newRows[index][RowsField.lotNo]
                // let t_pktno = id == RowsField.pktNo ? value : newRows[index][RowsField.pktNo]
                if (mixStockParams.hasOwnProperty(id))
                    funSetMixStockKeys(RowsField.lotNo, value, gridId)
            }


            if (gridId == ENUM_GRID.MixGrid) {
                const newRows = [...mixRows]
                let t_lotno = id == RowsField.lotNo ? value : newRows[index][RowsField.lotNo]
                let t_pktno = id == RowsField.pktNo ? value : newRows[index][RowsField.pktNo]
                if (selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle) {
                    let isDuplicate = 0;
                    if (selPktType == 'SNG' && t_lotno != "" && t_pktno != "") {
                        const pktData = mixRows.filter((ele) => ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                        if (pktData && pktData.length > 0) {
                            if (pktData[0].id != index + 1) {
                                isDuplicate = 1
                                toast.error("duplicate lot No and Pkt No. not allow", {
                                    position: "top-center"
                                })
                                newRows[index][RowsField.lotNo] = ""
                                newRows[index][RowsField.pktNo] = ""
                                setRows(newRows)
                            }
                        }
                    }
                    if (!isDuplicate) {
                        funChkPktLotNo({
                            data: {
                                compcode: compCode.join(","),
                                lotno: t_lotno,
                                pktNo: t_pktno
                            }
                        })
                    }
                }
                else if (selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToMix && selTradeOf == 'R' && t_lotno != "") {
                    funChkRoughNo({
                        data: {
                            compcode: compCode.join(","),
                            roughno: t_lotno,
                        }
                    })


                }

            }

        }
        else if (id == RowsField.pcs || id == RowsField.weight) {
            let newRows = []
            let chkPcsValue = 0
            let chkWeightValue = 0
            if (isMixGrid(gridId)) {
                chkWeightValue = total_OutWeight
                chkPcsValue = total_OutPcs
                newRows = [...mixRows]
            }
            else {
                newRows = [...rows]

                chkPcsValue = Number(newRows[index][RowsField.stkPcs]) + Number(newRows[index][RowsField.oldPcs])
                chkWeightValue = parseFloat(newRows[index][RowsField.stkWeight]) + parseFloat(newRows[index][RowsField.oldWeight])
            }
            if (chkPcsValue != "" || chkWeightValue != "") {

                //  funValidateStock(id, index, gridId, chkPcsValue, chkWeightValue, value)
                if (id == RowsField.pcs) {
                    if (Number(value) > Number(chkPcsValue)) {
                        toast.error(`Pcs should be less than (${chkPcsValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.pcs] = newRows[index][RowsField.oldPcs]
                    }

                }
                else if (id == RowsField.weight) {
                    if (parseFloat(value) > parseFloat(chkWeightValue)) {
                        toast.error(`Weight should be less than (${chkWeightValue})`, {
                            "position": "top-center",
                            "className": "toast-error",
                        })
                        newRows[index][RowsField.weight] = newRows[index][RowsField.oldWeight]
                    }

                }
                if (isMixGrid(gridId))
                    setMixRows(newRows)
                else
                    setRows(newRows)
            }

        }
        // else if (id == RowsField.lwRatio && gridId != ENUM_GRID.MixGrid) {
        //     if (mixStockParams.hasOwnProperty(id))
        //         funSetMixStockKeys(RowsField.lwRatio, value)
        // }

    }
    const funLoadMixStockData = (newObj) => {

        const allKeysHaveValue = Object.values(newObj).every(value => value != "" && value !== null && value != undefined);
        if (allKeysHaveValue) {
            let index = selectedGridRowId ?? 0
            const duplicateRows = rows.filter((item, i) => i !== index &&
                Object.entries(newObj).every(
                    ([key, value]) => item[key] === value
                )
            );
            // console.log(newObj, rows, duplicateRows, selectedGridRowId)


            filterMixStock({
                data: {
                    compcode: compCode.join(","),
                    itemcode: mixStockParams.hasOwnProperty(RowsField.itemCode) ? newObj[RowsField.itemCode] : null,
                    lotno: mixStockParams.hasOwnProperty(RowsField.lotNo) ? newObj[RowsField.lotNo] : null,
                    pktno: mixStockParams.hasOwnProperty(RowsField.pktNo) ? newObj[RowsField.pktNo] : null,
                    scode: mixStockParams.hasOwnProperty(RowsField.shapeCode) ? newObj[RowsField.shapeCode] : null,
                    shcode: mixStockParams.hasOwnProperty(RowsField.colorCode) ? newObj[RowsField.colorCode] : null,
                    qcode: mixStockParams.hasOwnProperty(RowsField.purityCode) ? newObj[RowsField.purityCode] : null,
                    szcode: mixStockParams.hasOwnProperty(RowsField.sizeCode) ? newObj[RowsField.sizeCode] : null,
                    lwcode: mixStockParams.hasOwnProperty(RowsField.lwRatio) ? newObj[RowsField.lwRatio] : null,
                    tradeof: selTradeOf
                }
            })

        }
    }

    const funSetMixStockKeys = (key, value, gridId) => {

        if (selPktType == 'MIX') {
            if (modSettingParams && modSettingParams?.MixStock) {

                if (mixStockParams.hasOwnProperty(key)) {
                    const newObj = { ...mixStockParams, [key]: value }
                    const allKeysHaveValue = Object.values(newObj).every(value => value !== "" && value !== null && value !== undefined);
                    if (allKeysHaveValue) {
                        let duplicate = 0
                        let index = selectedGridRowId ?? 0
                        let filterData = rows;
                        if (gridId == ENUM_GRID.MixGrid)
                            filterData = mixRows
                        const duplicateRows = filterData.filter((item, i) => i !== index &&
                            Object.entries(newObj).every(
                                ([key, value]) => item[key] === value
                            )
                        );
                        if (duplicateRows && duplicateRows?.length > 0) {

                            toast.error("duplicate items not allow it already added", {
                                position: "top-center",
                                "className": "toast-error",
                            })
                            const newRows = [...filterData]
                            Object.keys(newObj).map((ele) => {
                                newRows[index][ele] = ""
                            })
                            if (gridId == ENUM_GRID.MixGrid)
                                setMixRows(newRows)
                            else
                                setRows(newRows)
                        }
                        if (gridId != ENUM_GRID.MixGrid && !duplicate)
                            funLoadMixStockData(newObj)
                    }
                    setMixStockParams(newObj)
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target

        setFormData({ ...formData, [name]: value })
    }
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.mDate]: cdate,
            };
        });
        if (isNewEntry && selMixSlitType == 2 && cdate && cdate != "Invalid Date") {
            funMktLotNo(cdate)
        }
    }

    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        // if (!parsed.isValid()) {
        //     toast.error("Invalid date format. Use DD/MM/YYYY", {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     return;
        // }

        // // ❌ Out of allowed range
        // if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
        //     toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
        //         position: "top-center",
        //         className: "toast-error"
        //     });
        //     setFormData({ ...formData, [name]: null })
        //     return;
        // }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (isNewEntry && selMixSlitType == 2 && formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };
    const handleAutoCompleteChange = (gridId, value, rowid, name) => {
        if (name == formField.locationId) {
            setFormData({
                ...formData,
                [name]: value,
            })
        }

        else {
            if (name == RowsField.itemCode) {
                let val = value
                if (isMixGrid(gridId)) {
                    if (mixRows.find((ele) => ele.itemCode == value && ele.id != rowid)) {
                        addToast({
                            title: "",
                            description: "Item already added",
                            color: "danger"
                        })

                        val = ""
                    }
                    const index = mixRows.findIndex((ele) => ele.id == rowid)
                    let newRow = [...mixRows]
                    newRow[index].itemCode = val
                    setMixRows(newRow)
                }
                else {
                    if (rows.find((ele) => ele.itemCode == value && ele.id != rowid)) {
                        addToast({
                            title: "",
                            description: "Item already added",
                            color: "danger"
                        })
                        val = ""
                    }
                    const index = rows.findIndex((ele) => ele.id == rowid)
                    let newRow = [...rows]
                    newRow[index].itemCode = val
                    if (val != "")
                        funSetMixStockKeys(name, value, gridId)
                    setRows(newRow)

                }
            }
            else {


                let keyfield = name;
                if (isMixGrid(gridId)) {
                    const index = mixRows.findIndex((ele) => ele.id == rowid)
                    setSelectedGridRowId(index)
                    let newRow = [...mixRows]
                    if (name == RowsField.shapeCode) {
                        newRow[index][RowsField.objLwRatio] = getLwRatioByShape(value)
                    }
                    newRow[index][keyfield] = value
                    setMixRows(newRow)
                }
                else {
                    funSetMixStockKeys(keyfield, value, gridId)
                    const index = rows.findIndex((ele) => ele.id == rowid)
                    setSelectedGridRowId(index)
                    let newRow = [...rows]
                    if (name == RowsField.shapeCode) {
                        newRow[index][RowsField.objLwRatio] = getLwRatioByShape(value)
                    }
                    newRow[index][keyfield] = value
                    setRows(newRow)
                }



            }
        }
    }
    const isMixGrid = (gridId) => {
        if (gridId == ENUM_GRID.MixGrid)
            return true
        else
            return false

    }
    const handleDeleteRow = (gridId, id) => {

        if (gridId == ENUM_GRID.MixGrid) {
            const updatedRows = mixRows.filter((row) => row.id !== id)
            let DeletedRow = mixRows.filter((row) => row.id == id)
            const rearrangedRows = updatedRows.map((row, index) => {
                return {
                    ...row,
                    id: index + 1, // Reassign IDs to start from 1 again
                }
            })

            setMixRows(rearrangedRows)
            setDeletedItemMixRows([...deletedItemMixRows, ...DeletedRow])
        }
        else {
            const updatedRows = rows.filter((row) => row.id !== id)
            let DeletedRow = rows.filter((row) => row.id == id)
            const rearrangedRows = updatedRows.map((row, index) => {
                return {
                    ...row,
                    id: index + 1, // Reassign IDs to start from 1 again
                }
            })

            setRows(rearrangedRows)
            setDeletedItemRows([...deletedItemRows, ...DeletedRow])
        }

    }
    const funCalAllAmount = (gridId, rowData, index, pcs, weight, currentID) => {

        let newRows = [...rows]
        if (isMixGrid(gridId))
            newRows = [...mixRows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_DAmount = 0
        let tempVal = 0

        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        let t_DRate = newRows[index].dRate && newRows[index].dRate != null ? newRows[index].dRate : 0
        let t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        let t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0

        let conv_rate = newRows[index].convRate && newRows[index].convRate != null ? newRows[index].convRate : 0

        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            //&& CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
            if ((currentID == RowsField.dRate || currentID == RowsField.convRate)) {
                tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                t_rate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (currentID == RowsField.rate || currentID == RowsField.convRate) {
                tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                t_DRate = funCheckNumber(tempVal).toFixed(2)
            }
        }

        tempVal = parseFloat(t_rate) * parseFloat(t_weight)
        t_Amount = funCheckNumber(tempVal)
        tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
        t_DAmount = funCheckNumber(tempVal)



        //t_Amount = funCheckNumber(tempVal)
        return { amount: t_Amount.toFixed(2), dAmount: t_DAmount.toFixed(2), dRate: t_DRate, rate: t_rate }

    }

    const handleInputChange = (gridId, rowId, e, name) => {

        let { value, id } = e.target
        let index = 0
        let newRows = []
        if (isMixGrid(gridId)) {
            index = mixRows.findIndex(ele => ele.id == rowId)
            newRows = [...mixRows]
        }
        else {
            index = rows.findIndex(ele => ele.id == rowId)
            newRows = [...rows]
        }
        setSelectedGridRowId(index)
        newRows[index][id] = value
        const CalColumn = [RowsField.rate, RowsField.pcs, RowsField.weight, RowsField.dRate, RowsField.convRate]
        if (CalColumn.includes(id)
        ) {

            const calData = funCalAllAmount(gridId, newRows, index, 0, 0, id)
            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount

            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                if (id != RowsField.dRate)
                    newRows[index].dRate = calData.dRate //.toFixed(2)
                if (id != RowsField.rate)
                    newRows[index].rate = calData.rate //.toFixed(2)
            }

        }
        // if (id == RowsField.rate ||
        //     id == RowsField.pcs ||
        //     id == RowsField.weight
        // ) {

        //     const calData = funCalAllAmount(gridId, newRows, index, 0, 0)
        //     newRows[index].amount = calData.amount
        // }
        if (isMixGrid(gridId))
            setMixRows(newRows)
        else
            setRows(newRows)


    }
    const funIsFooter = (id) => {
        if (id == 100)
            return true
        else
            return false
    }

    const isDisableSubmit = () => {
        // if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
        //     const { status } = detailParams
        //     if (status == ENUM_STATUS.Final)
        //         return true
        //     else
        //         return false
        // }
        return false
    }

    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (

            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                labelPlacement="outside"
                isReadOnly={is_readonly}
                isDisabled={input_id == RowsField.lotNo || input_id == RowsField.pktNo ? is_readonly : false}
                placeholder={holder_text}
                //allow space in text box
                onBlur={(e) => handleBlur(row.gridId, row.id - 1, e, RowsField[input_id])}
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                size="sm"
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.gridId, row.id, e, RowsField[input_id])}
                className="max-w-xs mt-1"
                classNames={{
                    input: `${input_type == "number" ? "text-right" : ""}  text-xs `,

                }}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }
    const renderAutoCompleteCell = (itemData, itemKey, itemValue, row, autocomp_id, autocomp_name, is_readonly, holder_text, is_required, variant, color) => {
        return (
            <Autocomplete
                isRequired={is_required}//{setColumnRequired(RowsField[autocomp_id])}
                size="sm"
                color={color ? color : "default"}
                id={RowsField[autocomp_name]}
                eventResizeFeature={true}
                selectionMode="single"
                showScrollIndicators={true}
                placeholder="--Select--"
                className="max-w-23 text-2xl"
                menuTrigger={"input"}
                isClearable={false}
                isLoading={isLoadingData}
                isReadOnly={setColumnDisable(row)}
                isVirtualized
                defaultItems={
                    itemData ? itemData : []
                }
                onSelectionChange={(e) =>
                    handleAutoCompleteChange(row.gridId, e, row.id, RowsField[autocomp_id])
                }
                //onChange={handleFormSelectionChange}
                selectedKey={row[autocomp_id]}
            >
                {(item) => (
                    <AutocompleteItem
                        key={item[itemKey]}
                    >
                        {RowsField[autocomp_name] == RowsField.lwRatio ? item[itemKey] : item[itemKey] + "(" + item[itemValue] + ")"}
                    </AutocompleteItem>
                )}
            </Autocomplete>
        )
    }

    const setColumnRequired = (column) => {

        if ((selPktType == "MIX" && mixStockParams && mixStockParams.hasOwnProperty(column)))
            return true
        else if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }

    const setMixGridColumnRequired = (column) => {
        return selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnRequired(column)

    }
    //console.log(mixRows)
    const setColumnDisable = (row) => {
        if (isMixGrid(row.gridId)) {
            if (row.bWeight <= 0 && !isNewEntry && selMixSlitType == 2)
                return true
            else
                return false
        }
        else {
            const enableCol = [RowsField.pcs, RowsField.rate, rows.weight]
            if (!isNewEntry && row.detailId > 0) {
                return true
                // else
                //    return true
            }
            else
                return false
        }
    }
    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }
    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.stkRate, RowsField.amount]
        const DCol = [RowsField.dRate, RowsField.stkDRate, RowsField.dAmount, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }

    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>
                                {/* //{setColumnDisable(row) ? "" : */}
                                <FontAwesomeIcon
                                    color="red"
                                    className={`cursor-pointer`}
                                    onClick={() => handleDeleteRow(row.gridId, row.id)}
                                    icon={faSquareXmark}
                                ></FontAwesomeIcon>
                                {/* //} */}
                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            //...renderGridColumn("", "", RowsField.itemCode, "ItemCode", 80, "", "", "", "", "", "", "", "", "", "")
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.itemMaster ? masterData?.itemMaster : []
                                , "Item_Code", "Item_Desc", row, RowsField.itemCode, RowsField.itemName, false, "",
                                setColumnRequired(RowsField.itemName)
                                , "", "danger"
                            )
                        )

                    }

                </div>
            ),
        },
        {
            field: RowsField.lotNo,
            headerName: selPktType != 'SNG' && selTradeOf == 'R' ? "Rought No" : "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" :
                    (renderInputCell(row, RowsField.lotNo, "text",
                        setColumnDisable(row),
                        "",
                        setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",

            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{
                    funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.pktNo, "text",
                            setColumnDisable(row),
                            ""
                            , setColumnRequired(RowsField.pktNo)
                            , "", "")
                }</div>
            )
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.shapeMaster ? masterData?.shapeMaster : []
                                , "S_Code", "S_Name", row, RowsField.shapeCode, RowsField.shapeName, false, "",
                                setColumnRequired(RowsField.shapeName)
                                , "", "warning"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.colorMaster ? masterData?.colorMaster : []
                                , "Sh_Code", "Sh_Name", row, RowsField.colorCode, RowsField.colorName, false, "",
                                setColumnRequired(RowsField.colorName)
                                , "", "success"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.purityMaster ? masterData?.purityMaster : []
                                , "Q_Code", "Q_Name", row, RowsField.purityCode, RowsField.purityName, false, "",
                                setColumnRequired(RowsField.purityName)
                                , "", "primary"
                            )
                        )
                    }
                </div>
            ),
        },
        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.sizeMaster ? masterData?.sizeMaster : []
                                , "Sz_Code", "Sz_Name", row, RowsField.sizeCode, RowsField.sizeName, false, "",
                                setColumnRequired(RowsField.sizeName)
                                , "", "default"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(row[RowsField.objLwRatio] ? row[RowsField.objLwRatio] : []
                                , "LwCode", "LwCode", row, RowsField.lwRatio, RowsField.lwRatio, false, "",
                                setColumnRequired(RowsField.lwRatio)
                                , "", "success"
                            )
                        )
                    }
                    {/* {
                        funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
                            setColumnDisable(row),
                            "", false, "", "")
                    } */}
                </div>
            )
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.reportNo, "text",
                    setColumnDisable(row),
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lab, "text",
                    setColumnDisable(row),
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.stkPcs,
            headerName: "Stk Pcs",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >0</div> :
                    renderInputCell(row, RowsField.stkPcs, "number",
                        true,
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.stkWeight,
            headerName: "Stk Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">0</div>
                    : renderInputCell(row, RowsField.stkWeight, "number",
                        true,
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.stkRate,
            headerName: "Stk Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> 0</div> :
                renderInputCell(row, RowsField.stkRate, "number",
                    true,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.stkDRate,
            headerName: "Stk Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> 0</div> :
                renderInputCell(row, RowsField.stkDRate, "number",
                    false,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.pcs,
            headerName: "Out Pcs",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_OutPcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number", false,
                        // setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Out Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_OutWeight}</div>
                    : renderInputCell(row, RowsField.weight, "number", false,
                        // setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Out Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.dRate, "number",
                    setColumnDisable(row),
                    // CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? setColumnDisable(row) : true,
                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Out Amount($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.dAmount]
                    }
                </div>)
        },
        {
            field: RowsField.convRate,
            headerName: "conv.Rate",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" ></div> :
                    renderInputCell(row, RowsField.convRate, "number",
                        false,// setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.rate,
            headerName: "Out Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.rate, "number", false,
                    // setColumnDisable(row),
                    "", true, "", "")
            }</div>
            )
        },

        {
            field: RowsField.amount,
            headerName: "Out Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.amount]
                    }
                </div>)
        },

        {
            field: RowsField.remarks,
            headerName: "Remarks",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"></div> :
                renderInputCell(row, RowsField.remarks, "text",
                    setColumnDisable(row),
                    "", false, "", "")
            }</div>
            )
        },

    ]

    const mixColumns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>
                                {setColumnDisable(row) ? "" :
                                    <FontAwesomeIcon
                                        color="red"
                                        className={`cursor-pointer`}
                                        onClick={() => handleDeleteRow(ENUM_GRID.MixGrid, row.id)}
                                        icon={faSquareXmark}
                                    ></FontAwesomeIcon>
                                }
                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            //...renderGridColumn("", "", RowsField.itemCode, "ItemCode", 80, "", "", "", "", "", "", "", "", "", "")
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (<div>
                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.itemMaster ? masterData?.itemMaster : []
                                , "Item_Code", "Item_Desc", row, RowsField.itemCode, RowsField.itemName, false, "",
                                false
                                , "", "danger"
                            )
                        )

                    }

                </div>
            ),
        },
        {
            field: RowsField.lotNo,
            headerName: selPktType != 'SNG' && selTradeOf == 'R' ? "Rought No" : "Lot No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" :
                    (renderInputCell(row, RowsField.lotNo, "text",
                        selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle && !isNewEntry && row.detailId > 0 ? true : setColumnDisable(row), "",
                        setMixGridColumnRequired(RowsField.pktNo)
                        //selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",

            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{
                    funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.pktNo, "text",
                            selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle && !isNewEntry && row.detailId > 0 ? true : setColumnDisable(row),
                            ""
                            , setMixGridColumnRequired(RowsField.pktNo)
                            , "", "")
                }</div>
            )
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.shapeMaster ? masterData?.shapeMaster : []
                                , "S_Code", "S_Name", row, RowsField.shapeCode, RowsField.shapeName, false, "",
                                setMixGridColumnRequired(RowsField.shapeName)
                                , "", "warning"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.colorMaster ? masterData?.colorMaster : []
                                , "Sh_Code", "Sh_Name", row, RowsField.colorCode, RowsField.colorName, false, "",
                                setMixGridColumnRequired(RowsField.colorName)
                                , "", "success"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.purityMaster ? masterData?.purityMaster : []
                                , "Q_Code", "Q_Name", row, RowsField.purityCode, RowsField.purityName, false, "",
                                setMixGridColumnRequired(RowsField.purityName)
                                , "", "primary"
                            )
                        )
                    }
                </div>
            ),
        },
        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(masterData && masterData.sizeMaster ? masterData?.sizeMaster : []
                                , "Sz_Code", "Sz_Name", row, RowsField.sizeCode, RowsField.sizeName, false, "", false, "", "default"
                            )
                        )
                    }


                </div>
            ),
        },
        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        (
                            renderAutoCompleteCell(row[RowsField.objLwRatio] ? row[RowsField.objLwRatio] : []
                                , "LwCode", "LwCode", row, RowsField.lwRatio, RowsField.lwRatio, false, "", false, "", "success"
                            )
                        )
                    }
                    {/* {
                        funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
                            setColumnDisable(row),
                            "", false, "", "")
                    } */}
                </div>
            )
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.reportNo, "text",
                    setColumnDisable(row),
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lab, "text",
                    setColumnDisable(row),
                    "", false, "", "")
                }</div>
            )
        },

        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_OutPcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Merge Weight",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_OutWeight}</div>
                    : renderInputCell(row, RowsField.weight, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Merege Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.dRate, "number",
                    setColumnDisable(row),
                    // CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? setColumnDisable(row) : true,
                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Value($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.dAmount]
                    }
                </div>)
        },
        {
            field: RowsField.convRate,
            headerName: "conv.Rate",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" ></div> :
                    renderInputCell(row, RowsField.convRate, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.rate,
            headerName: "Merge Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_OutRate}</div> :
                renderInputCell(row, RowsField.rate, "number",
                    setColumnDisable(row),
                    "", true, "", "")
            }</div>
            )
        },

        {
            field: RowsField.amount,
            headerName: "Value",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: mixGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_OutAmount}</div> : row[RowsField.amount]
                    }
                </div>)
        },

        {
            field: RowsField.remarks,
            headerName: "Remarks",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: mixGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"></div> :
                renderInputCell(row, RowsField.remarks, "text",
                    setColumnDisable(row),
                    "", false, "", "")
            }</div>
            )
        },

    ]
    const [errors, setErrors] = useState({})



    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Vou No. required"
        }


        if (formData[formField.mDate] == null || formData[formField.mDate] == "" || formData[formField.mDate] == "Invalid Date") {
            newErrors[formField.mDate] = "Date required"
        }



        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
                if (rows[i].pcs == "" || rows[i].pcs == "0") {
                    if (!msg.includes("Pcs"))
                        msg = msg + "  Pcs ,";
                    no = 1
                }
                if (rows[i].rate == "" || rows[i].rate == "0") {
                    if (!msg.includes("Rate"))
                        msg = msg + "  Rate ,";
                    no = 1
                }
                if (rows[i].weight == "" || rows[i].weight == "0") {
                    if (!msg.includes("Weight"))
                        msg = msg + "  Weight ,";
                    no = 1
                }
                if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                    if (rows[i].convRate == "" || rows[i].convRate == "0") {
                        if (!msg.includes("Conv. Rate"))
                            msg = msg + "  Conv. Rate ,";
                        no = 1
                    }
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required in stock items"
        else return ""
    }
    const ValidateMixGrid = () => {
        let no = 0
        let msg = ""
        if (mixRows.length > 0) {
            for (let i = 0; i < mixRows.length; i++) {
                if (mixRows[i].pcs == "" || mixRows[i].pcs == "0") {
                    if (!msg.includes("Pcs"))
                        msg = msg + "  Pcs ,";
                    no = 1
                }
                if (mixRows[i].rate == "" || mixRows[i].rate == "0") {
                    if (!msg.includes("Rate"))
                        msg = msg + "  Rate ,";
                    no = 1
                }
                if (mixRows[i].weight == "" || mixRows[i].weight == "0") {
                    if (!msg.includes("Weight"))
                        msg = msg + "  Weight ,";
                    no = 1
                }
                if (selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle) {
                    if (mixRows[i].lotNo == "" || mixRows[i].lotNo == "0") {
                        if (!msg.includes("LotNo"))
                            msg = msg + "  Lot No ,";
                        no = 1
                    }
                    if (mixRows[i].pktNo == "" || mixRows[i].pktNo == "0") {
                        if (!msg.includes("PktNo"))
                            msg = msg + " Pkt No ,";
                        no = 1
                    }
                }
                if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                    if (mixRows[i].convRate == "" || mixRows[i].convRate == "0") {
                        if (!msg.includes("Conv. Rate"))
                            msg = msg + "  Conv. Rate ,";
                        no = 1
                    }
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required in mix items list"
        else return ""
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (selMixSlitType == 2 && !isUseMfgNoAsMktno && (mktLotNo == '' || mktLotNo == null || mktLotNo == '0')) {
            toast.error("Lot No Series Not Found", {
                "position": "top-center",
            })
            return;
        }
        // const rowsData = rows.filter(ele => ele.id != 100)
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()
        const mixgrid_msg = ValidateMixGrid()

        if (grid_msg == "" && mixgrid_msg == "" && validate_form) {
            if (total_OutWeight === total_MergeWeight) {
                funAddUpdate({
                    data: {
                        comp_code: compCode.join(","),
                        trans_id: formData[formField.transId],
                        item_list: rows,
                        mixitem_list: mixRows,
                        deleteditem_list: deletedItemRows,
                        deletedmixitem_list: deletedItemMixRows,
                        location_id: formData[formField.locationId],
                        vou_no: formData[formField.vouNo],
                        trade_of: selTradeOf,
                        pkt_type: selPktType == 'SNG' ? selPktType : "",
                        m_date: formData[formField.mDate],
                        mkt_lotno: isUseMfgNoAsMktno ? 0 : mktLotNo,
                        // isstock_entry: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : false,
                        login_userid: user.username,
                        entry_type: selMixSlitType,
                        rec_status: !isNewEntry ? 1 : 2
                    }
                })
            }
            else {
                toast.error("Out Weight and Merger Weight should be equale", {
                    "position": "top-center",
                    "className": "toast-error",
                })
            }
        }
        else {
            if (grid_msg != "") {
                addToast({
                    title: "",
                    description: grid_msg,
                    color: "danger"
                })
            }
            if (mixgrid_msg != "") {
                toast.error(mixgrid_msg, {
                    "position": "top-center"
                })
            }
        }
    }
    useEffect(() => {
        if (isGetMixStock) {
            if (!isNewEntry && rows && rows.length > 0 && selPktType != 'SNG' && mixStockParams && Object.keys(mixStockParams).length > 0) {
                let isSet = 0
                rows.map((item, index) => {
                    let newObj = {}

                    if (item.stkWeight <= 0) {

                        setSelectedGridRowId(index)
                        Object.keys(mixStockParams).map((mapkey) => {
                            newObj = { ...newObj, [mapkey]: item[mapkey] }
                        })
                        const allKeysHaveValue = Object.values(newObj).every(value => value !== "" && value !== null && value !== undefined);
                        if (allKeysHaveValue) {
                            CheckMixStock({
                                data: {
                                    compcode: compCode.join(","),
                                    itemcode: mixStockParams.hasOwnProperty(RowsField.itemCode) ? newObj[RowsField.itemCode] : null,
                                    lotno: mixStockParams.hasOwnProperty(RowsField.lotNo) ? newObj[RowsField.lotNo] : null,
                                    pktno: mixStockParams.hasOwnProperty(RowsField.pktNo) ? newObj[RowsField.pktNo] : null,
                                    scode: mixStockParams.hasOwnProperty(RowsField.shapeCode) ? newObj[RowsField.shapeCode] : null,
                                    shcode: mixStockParams.hasOwnProperty(RowsField.colorCode) ? newObj[RowsField.colorCode] : null,
                                    qcode: mixStockParams.hasOwnProperty(RowsField.purityCode) ? newObj[RowsField.purityCode] : null,
                                    szcode: mixStockParams.hasOwnProperty(RowsField.sizeCode) ? newObj[RowsField.sizeCode] : null,
                                    lwcode: mixStockParams.hasOwnProperty(RowsField.lwRatio) ? newObj[RowsField.lwRatio] : null,
                                    tradeof: selTradeOf
                                },
                                onSuccess: (data) => {
                                    if (data && data.length > 0) {

                                        const updatedItem = {
                                            stkPcs: data[0].pcs,
                                            stkWeight: data[0].weight,
                                        };
                                        setRows(prevRows =>
                                            prevRows.map((row, i) =>
                                                i === index ? { ...row, ...updatedItem } : row
                                            )
                                        )
                                        // console.log(index, rows.length - 1)
                                        if (index == (rows.length - 1)) {
                                            setIsGetMixStock(false)
                                        }
                                    }
                                }

                            })
                        }
                    }
                })
            }

        }
    }, [rows, isGetMixStock])

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            //const newData = [...gridData, { id: 100, ...initialRow }].sort((a, b) => a.id - b.id)
            setRows(gridData)

            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                setSelMixSlitType(detail?.itemData[0]?.Entry_Type ?? "")
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.locationId]: detail?.itemData[0]?.DivId.trim() ?? "",
                    [formField.mDate]: detail?.itemData[0]?.MDate ?? "",

                })
                const mixGridData = detail?.itemData.map((item, i) => {
                    return {
                        ...initialRow,
                        id: ++i,
                        gridId: ENUM_GRID.MixGrid,
                        transId: item?.TransactionId ?? "",
                        detailId: item?.DetailId ?? null,
                        itemCode: item?.MItem_Code ?? "",
                        pcs: item?.MPcs ?? 0,
                        weight: item?.MCarat ?? 0,
                        rate: item?.MRs_Rate ?? 0,
                        convRate: item?.MC_Rate ?? 0,
                        dRate: item?.MDRate ?? 0,
                        dAmount: funGetAmtD(item?.MCarat ?? 0, item?.MRs_Rate ?? 0, item?.MC_Rate ?? 0),
                        amount: funGetAmt(item?.MCarat ?? 0, item?.MRs_Rate ?? 0),
                        detailId: item?.DetailId ?? 0,
                        stkDRate: item?.BMDRate ?? 0,
                        stkRate: item?.BMRsRate ?? 0,
                        stkPcs: item?.BMPcs ?? 0,
                        stkWeight: item?.BMCarat ?? 0,
                        lotNo: item?.ML_Code ?? "",
                        pktNo: item?.MPktNo ?? "",
                        sLotNo: item?.MSL_Code ?? "",
                        sPktNo: item?.MSPktNo ?? "",
                        lwRatio: item?.MLW_Code ?? "",
                        objLwRatio: getLwRatioByShape(item?.MS_Code ?? ""),
                        shapeCode: item?.MS_Code ?? "",
                        colorCode: item?.MSha_Code ?? "",
                        purityCode: item?.MQ_Code ?? "",
                        sizeCode: item?.MSz_Code ?? "",
                        bWeight: item?.BWeight ?? "",
                        bPcs: item?.BPcs ?? "",
                        remarks: item?.Remark ?? "",
                    }
                })
                setMixRows(mixGridData)
            }
        }

    }, [detail, masterData])

    const funGetMasterLink = () => {
        let url = ""
        if (selMixSlitType == 2)
            return naviCode + mtrdtype + "/" + URIEncrypt.SinglePacket + linksUrl.mixslitEntry.mixslitEntryMaster;
        else
            return naviCode + mtrdtype + "/" + mptype + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster;
    }
    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleAddRow = (id) => {
        let new_initialRow = initialRow
        if (modSettingParams && modSettingParams.Visibility) {

            if (Object.keys(modSettingParams.Visibility).length > 0) {
                //set default value to hidden grid column setting based
                const hiddenCol = Object.entries(modSettingParams.Visibility)
                    .filter(([key, value]) => value == false) // filter where value is true
                    .map(([key, value]) => {
                        return { [key]: modSettingParams.Value[key] }
                    });

                const result = hiddenCol.reduce((acc, current) => {
                    return { ...acc, ...current };
                }, {});

                if (result && Object.keys(result).length > 0)
                    new_initialRow = { ...initialRow, ...result }
            }

        }

        if (id == ENUM_GRID.MixGrid) {
            let newId = mixRows.length + 1
            const newRow = { ...new_initialRow, gridId: ENUM_GRID.MixGrid, id: newId, }
            setMixRows([...mixRows, newRow])

            setTimeout(() => {
                const gridScroller = mixGridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
                if (gridScroller) {
                    gridScroller.scrollLeft = 0; // Scroll to the left
                }
            }, 250)
            setTimeout(() => {
                const firstCell = mixGridContainerRef.current?.querySelector(
                    `[data-id="${newId}"] [data-field="id"]`
                );
                if (firstCell) {
                    firstCell.focus();
                }
            }, 500);
        }
        else {
            let newId = rows.length + 1
            const newRow = { gridId: ENUM_GRID.SourceGrid, id: newId, ...new_initialRow, }
            setRows([...rows, newRow])

            setTimeout(() => {
                const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
                if (gridScroller) {
                    gridScroller.scrollLeft = 0; // Scroll to the left
                }

            }, 250)
            setTimeout(() => {
                const firstCell = gridContainerRef.current?.querySelector(
                    `[data-id="${newId}"] [data-field="id"]`
                );
                if (firstCell) {
                    firstCell.focus();
                }
            }, 500);


        }

    }
    const handleNewAcEntry = () => {
        let redLink = naviCode + mtrdtype + "/" + mptype + linksUrl.mixEntry.CreateMixSlitEntry
        if (selPktType == 'MIX')
            redLink = naviCode + mtrdtype + "/" + mptype + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry

        dispatch(setRedirectLink(redLink))
        navigate(linksUrl.master.account.createAccountMaster)
    }
    const handleRadioChange = (value) => {
        setSelMixSlitType(value)
        // if (value == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle) {
        //     setVisibilityModel((prev) => ({
        //         ...prev,
        //         [RowsField.lotNo]: true,
        //         [RowsField.pktNo]: true,
        //         [RowsField.shapeCode]: true,
        //         [RowsField.colorCode]: true,
        //         [RowsField.purityCode]: true,
        //     }));
        // }
        // else {
        //     setVisibilityModel({ ...funGetMixGridVisiblityModel })
        // }
        const data = mixRows.map((ele) => {
            return {
                ...ele, [RowsField.lotNo]: "", [RowsField.pktNo]: ""
            }
        })
        setMixRows(data)
    }

    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Mix Slit Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[entryLabel, "Mix Slit Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <>
                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoadingData}
                                                                menuTrigger={"input"}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                readonly={isNewEntry ? false : true}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange("", e, '', item.name)
                                                                }
                                                                color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : "warning"}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                            {item.name == formField.partyId ?
                                                                <Chip className="cursor-pointer bg-slate-400" color={"default"} onClick={handleNewAcEntry}>New A/C.</Chip>
                                                                : ""}
                                                        </>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => handleDateChange(newValue)}
                                                                    // setFormData((prev) => {
                                                                    //     return {
                                                                    //         ...prev,
                                                                    //         [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                    //             dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                    //     };
                                                                    // });
                                                                    //}}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            onBlur={(e) => handleBlur("", "", e, item.name)}
                                                            readOnly={item.name == formField.vouNo ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                //inputWrapper:"bg-red-700 h-1 px-2 m-0",
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            <div>
                                <div className="flex justify-between items-center">
                                    <Button size="sm" color="success" radius="sm" className="text-white cursor-default  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                        onPress={() => handleAddRow("")}>
                                        ADD ITEM
                                    </Button>
                                    <h6 className="text-sm text-green-700" >Total Items : {rows && rows.length > 0 ? rows.length : 0}</h6>
                                </div>
                                {rows && rows?.length > 0 ? (
                                    <div>
                                        <Box ref={gridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                            <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                editMode="row"
                                                hideFooterPagination={true}
                                                hideFooter={true}
                                                columnHeaderHeight={30}
                                                rowHeight={43}
                                                disableColumnSorting={true}
                                                disableColumnMenu={true}
                                                getRowClassName={(params) => {
                                                    return 'row-class';
                                                }}
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1, // Make sure the headers are above the rows when scrolling
                                                    },
                                                    '& .row-class': {
                                                        fontSize: "12px",
                                                    },
                                                }}
                                                columnVisibilityModel={{
                                                    [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                    [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                    [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                    [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                    [RowsField.shapeName]: setColumnVisiblity(RowsField.shapeCode),
                                                    [RowsField.colorName]: setColumnVisiblity(RowsField.colorCode),
                                                    [RowsField.purityName]: setColumnVisiblity(RowsField.purityCode),
                                                    [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                    [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                    [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                    [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                    [RowsField.stkDRate]: setCurrencyColumnVisiblity(RowsField.stkDRate),
                                                    [RowsField.remarks]: setColumnVisiblity(RowsField.remarks),
                                                    [RowsField.stkRate]: setCurrencyColumnVisiblity(RowsField.stkRate),
                                                    [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                    [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                    [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                    [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                    [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                }}

                                            />

                                        </Box>

                                        <div className="flex  items-top gap-2 mt-1 bg-slate-100 p-2 ">
                                            <Input size="sm" readOnly={true} label="Packet" labelPlacement="outside" color="primary" value={rows ? rows?.length ?? 0 : 0} className="bg-sky-700"
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }
                                            ></Input>
                                            <Input size="sm" readOnly={true} label="Out Weight" labelPlacement="outside" color="danger" className="bg-rose-700" value={total_OutWeight}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }> </Input>
                                            <Input size="sm" readOnly={true} label="Pcs" labelPlacement="outside" color="default" className="bg-slate-700" value={total_OutPcs}> </Input>
                                            {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                                <>
                                                    <Input size="sm" readOnly={true} label=" Out Amount" labelPlacement="outside" color="success" className="bg-lime-500" value={total_OutAmount}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">₹</span>
                                                            </div>
                                                        }
                                                    > </Input>
                                                    <Input size="sm" readOnly={true} label="Avg Rate" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_Rate}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">₹</span>
                                                            </div>
                                                        }
                                                    >  </Input>
                                                </>}
                                            {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                                <>
                                                    <Input size="sm" readOnly={true} label="Amount($)" labelPlacement="outside" color="success" className="bg-lime-500" value={total_OutAmountD}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">$</span>
                                                            </div>
                                                        }
                                                    > </Input>
                                                    <Input size="sm" readOnly={true} label="Avg Rate($)" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_RateD}
                                                        startContent={
                                                            <div className="pointer-events-none flex items-center">
                                                                <span className="text-default-400 text-small">$</span>
                                                            </div>
                                                        }
                                                    >  </Input>
                                                </>}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>

                            {/* {(isNewEntry && selMixSlitType != "") || !isNewEntry ? ( */}
                            {rows && rows.length > 0 ? (
                                <div>
                                    <div className="flex justify-between items-center mt-3">
                                        <Button size="sm" color="primary" radius="sm" className="text-white cursor-default  text-xs bg-orange-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                            onPress={() => handleAddRow(ENUM_GRID.MixGrid)}>
                                            ADD MIX ITEM
                                        </Button>
                                        <h6 className="text-sm text-green-700" >Total Items : {mixRows && mixRows.length > 0 ? mixRows?.length : 0}</h6>
                                    </div>
                                    {mixRows && mixRows?.length > 0 ? (
                                        <div>
                                            <Box ref={mixGridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                                <DataGrid
                                                    rows={mixRows}
                                                    columns={mixColumns}
                                                    editMode="row"
                                                    hideFooterPagination={true}
                                                    hideFooter={true}
                                                    columnHeaderHeight={30}
                                                    rowHeight={43}
                                                    disableColumnSorting={true}
                                                    disableColumnMenu={true}
                                                    getRowClassName={(params) => {
                                                        return 'row-class';
                                                    }}
                                                    sx={{
                                                        '& .MuiDataGrid-columnHeaders': {
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1, // Make sure the headers are above the rows when scrolling
                                                        },
                                                        '& .row-class': {
                                                            fontSize: "12px",
                                                        },
                                                    }}
                                                    columnVisibilityModel={{
                                                        [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                        [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                        [RowsField.lotNo]: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnVisiblity(RowsField.lotNo),
                                                        [RowsField.pktNo]: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnVisiblity(RowsField.pktNo),
                                                        [RowsField.shapeName]: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnVisiblity(RowsField.shapeCode),
                                                        [RowsField.colorName]: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnVisiblity(RowsField.colorCode),
                                                        [RowsField.purityName]: selMixSlitType == ENUM_MIXSLIT_ENTRYTYPE.MixToSingle ? true : setColumnVisiblity(RowsField.purityCode),
                                                        [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                        [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                        [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                        [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                        [RowsField.stkDRate]: setCurrencyColumnVisiblity(RowsField.stkDRate),
                                                        [RowsField.remarks]: setColumnVisiblity(RowsField.remarks),
                                                        [RowsField.stkRate]: setCurrencyColumnVisiblity(RowsField.stkRate),
                                                        [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                        [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                        [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                        [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                        [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                    }}
                                                // onColumnVisibilityModelChange={(newModel) => setVisibilityModel(newModel)}




                                                />

                                            </Box>

                                            <div className="flex  items-top gap-2 mt-1 bg-slate-100 p-2 ">
                                                <Input size="sm" readOnly={true} label="Packet" labelPlacement="outside" color="primary" value={mixRows ? mixRows?.length ?? 0 : 0} className="bg-sky-700"
                                                    startContent={
                                                        <div className="pointer-events-none flex items-center">
                                                            <span className="text-default-400 text-small">₹</span>
                                                        </div>
                                                    }
                                                ></Input>
                                                <Input size="sm" readOnly={true} label="Mix Weight" labelPlacement="outside" color="danger" className="bg-rose-700" value={total_MergeWeight}
                                                    startContent={
                                                        <div className="pointer-events-none flex items-center">
                                                            <span className="text-default-400 text-small">₹</span>
                                                        </div>
                                                    }> </Input>
                                                <Input size="sm" readOnly={true} label="Pcs" labelPlacement="outside" color="default" className="bg-slate-700" value={total_MergePcs}> </Input>
                                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                                    <>
                                                        <Input size="sm" readOnly={true} label=" Mix Amount" labelPlacement="outside" color="success" className="bg-lime-500" value={total_MergeAmount}
                                                            startContent={
                                                                <div className="pointer-events-none flex items-center">
                                                                    <span className="text-default-400 text-small">₹</span>
                                                                </div>
                                                            }
                                                        > </Input>
                                                        <Input size="sm" readOnly={true} label="Avg Mix Rate" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_MergeRate}
                                                            startContent={
                                                                <div className="pointer-events-none flex items-center">
                                                                    <span className="text-default-400 text-small">₹</span>
                                                                </div>
                                                            }
                                                        >  </Input></>}
                                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                                    <>
                                                        <Input size="sm" readOnly={true} label=" Mix Amount($)" labelPlacement="outside" color="success" className="bg-lime-500" value={total_MergeAmountD}
                                                            startContent={
                                                                <div className="pointer-events-none flex items-center">
                                                                    <span className="text-default-400 text-small">$</span>
                                                                </div>
                                                            }
                                                        > </Input>
                                                        <Input size="sm" readOnly={true} label="Avg Mix Rate($)" labelPlacement="outside" color="warning" className="bg-amber-500" value={Avg_MergeRateD}
                                                            startContent={
                                                                <div className="pointer-events-none flex items-center">
                                                                    <span className="text-default-400 text-small">$</span>
                                                                </div>
                                                            }
                                                        >  </Input>
                                                    </>}
                                            </div>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            ) : ""}

                            <div className="justify-center flex gap-5 mt-5">
                                <div className=" p-2 border-1 mt-3 items-center">
                                    <RadioGroup orientation="horizontal" isRequired isReadOnly={isNewEntry ? false : true} className="w-full" size="sm" color="success" value={selMixSlitType}
                                        onValueChange={handleRadioChange}>
                                        <Radio
                                            isDisabled={ClientSetting == ENUM_CLIENT_SETTING_VAL.MIX ? true : false}
                                            value={ENUM_MIXSLIT_ENTRYTYPE.MixToSingle}>Mix To Single</Radio>
                                        <Radio value={ENUM_MIXSLIT_ENTRYTYPE.MixToMix}>Mix To Mix</Radio>
                                        {isNewEntry ? "" :
                                            <Radio value={ENUM_MIXSLIT_ENTRYTYPE.SingleToMix}>Single To Mix</Radio>}
                                    </RadioGroup>

                                </div>
                                <Button
                                    color="primary"
                                    type="submit"
                                    size="md"
                                    variant="shadow"
                                    isDisabled={isDisableSubmit()}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="md"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </CardBody>
                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default CreateMixSlitEntry
